// src/components/common/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Diese Komponente sorgt dafür, dass bei einem Routenwechsel zum oberen Rand der Seite gescrollt wird.
 * Sie wird als direktes Kind des Routers eingebunden und hat keine visuelle Ausgabe (null).
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wenn kein Hash in der URL vorhanden ist, scrolle zum absoluten Seitenanfang
    if (!hash) {
      // Sofort scrollen, ohne auf Rendering zu warten
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Zusätzlich einen erneuten Scroll nach kurzer Verzögerung ausführen,
      // um sicherzustellen, dass Header und alles vollständig geladen ist
      const timer = setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 100);
      
      return () => clearTimeout(timer);
    }
    // Bei Hash-Navigation lassen wir die spezifische Implementierung in den jeweiligen Komponenten arbeiten
  }, [pathname, hash]);

  return null; // Diese Komponente rendert nichts
}

export default ScrollToTop;